var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgContactUsMail = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 21,
    viewBox: "0 0 32 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 0H4C1.791 0 0 1.792 0 4V17C0 19.209 1.791 21 4 21H28C30.209 21 32 19.209 32 17V4C32 1.792 30.209 0 28 0ZM2 5.25L8.999 10.5L2 15.75V5.25ZM30 17C30 18.104 29.102 19 28 19H4C2.897 19 2 18.104 2 17L9.832 11.125L14.2 14.402C14.733 14.8 15.366 15.002 16 15.002C16.633 15.002 17.266 14.801 17.799 14.402L22.168 11.125L30 17ZM30 15.75L23 10.5L30 5.25V15.75ZM17.199 13.602C16.85 13.864 16.436 14.002 16 14.002C15.564 14.002 15.149 13.863 14.8 13.602L10.665 10.5L9.832 9.875L2 4.001V4C2 2.897 2.897 2 4 2H28C29.102 2 30 2.897 30 4L17.199 13.602Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgContactUsMail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/contact-us-mail.ddea657c5a8ddd1122d792183923439b.svg";